import { ElectronTsdownError } from './ElectronTsdownError.js'

export class LaunchError extends ElectronTsdownError {}
